const API_BASE = (process.env.NODE_ENV == 'production') ? 'https://api.spanindia.letstream.one/' : ((window.location.hostname.search("localhost") >= 0) ? 'http://localhost.theletstream.com:8009/' : 'https://e32proxier8009.theletstream.com/');
const AUTH_BASE = (process.env.NODE_ENV == 'production') ? 'https://api.spanindia.letstream.one/' : ((window.location.hostname.search("localhost") >= 0) ? 'http://localhost.theletstream.com:8009/' : 'https://e32proxier8009.theletstream.com/');
// console.log("Using API BASE as " + API_BASE)
// console.log("Using AUTH BASE as " + AUTH_BASE)

const apiendpoints = {
    api_base: API_BASE,
    api_base_noslash: API_BASE.slice(0, -1),
    auth_base: AUTH_BASE,
    auth_base_noslash: AUTH_BASE.slice(0, -1),

    // Accounts
    login: AUTH_BASE + 'accounts/login/',
    register: AUTH_BASE + 'accounts/register/',
    profile: AUTH_BASE + 'dashboard/profile/',
    get_users: API_BASE + 'dashboard/users/browse/',
    user_profile: API_BASE + 'accounts/user/',
    user_role: API_BASE + 'accounts/user/role/',

    // Notifications
    notifications_fcm: API_BASE + 'notifications/fcm/',

    // Custom

    entity: API_BASE + 'data/entity/',
    entity_list: API_BASE + 'data/entities/',

    portfolio: API_BASE + 'data/portfolio/',
    portfolio_list: API_BASE + 'data/portfolios/',

    broker: API_BASE + 'data/broker/',
    broker_list: API_BASE + 'data/brokers/',

    demat_account: API_BASE + 'data/demat-account/',
    demat_account_list: API_BASE + 'data/demat-accounts/',

    alias: API_BASE + 'data/alias/',
    alias_list: API_BASE + 'data/aliases/',

    share: API_BASE + 'data/share/',
    share_list: API_BASE + 'data/shares/',

    contract: API_BASE + 'contract/',
    contract_list: API_BASE + 'contract/list/',

    transaction_report: API_BASE + 'contract/transaction-report/',
    summary_report: API_BASE + 'contract/summary-report/',

    //create excel
    excel_create: API_BASE + 'export/excel/create/',
    excel_list: API_BASE + 'export/excel/list/',

    scrip_fifo_table: API_BASE + 'data/scrip-fifo-table/',
    live_fifo_table: API_BASE + 'data/live-fifo-table/',
    live_fifo_table_new: API_BASE + 'data/live-fifo-table/new/',

    scrip_type_list: API_BASE + 'data/scrip-types/',
    industry_list: API_BASE + 'data/industries/',

    corporate_action: API_BASE + 'corporate-actions/create/',
    corporate_action_rud: API_BASE + 'corporate-actions/',
    bonus_action: API_BASE + 'corporate-actions/bonus-action/preview/',
}

export default apiendpoints
